const MILLION = 1_000_000;
const THOUSANDS_PLACEHOLDER = "!THOUSANDS_PLACEHOLDER#";
const DECIMAL_PLACEHOLDER = "!DECIMAL_PLACEHOLDER#";

export default function formatNumber(
  value: number | null | undefined,
  precision: number,
  unit: string | null = null,
  thousandsSeparator: string = " ",
  def: string = "",
): string {
  if (value || value === 0) {
    const million = Math.abs(value) >= MILLION;
    return (
      (million ? value / MILLION : value)
        .toLocaleString("en-US", {
          maximumFractionDigits: million ? 0 : precision,
        })
        .replaceAll(",", THOUSANDS_PLACEHOLDER)
        .replaceAll(".", DECIMAL_PLACEHOLDER)
        .replaceAll(THOUSANDS_PLACEHOLDER, thousandsSeparator)
        .replaceAll(DECIMAL_PLACEHOLDER, ".") +
      (million ? " M" : "") +
      (unit ? ` ${unit}` : "")
    );
  }
  return def;
}
